import {SERVICES} from '@/const';

const PREFIX = `${SERVICES.STATIC_URL}/s/`;
const PREFIX_STATIC = `${SERVICES.STATIC_URL}/pubimg/`;

export const IMAGES = {
  ASSETS_SIXTY_BONUS: 'home/assets/60-bonus.png',
  ASSETS_LIGHTNING: 'home/assets/lightning.png',
  QRCODE: `web/assets/qrcode.svg`,
  GOUXUAN: `web/assets/gouxuan.svg`,
  COPY: `web/assets/copy.svg`,
  GIVE_AWAY_PNG: `web/assets/give_away.svg`,
};

Object.keys(IMAGES).forEach((key) => (IMAGES[key] = [PREFIX, IMAGES[key]].join('')));

export const LAUNCHPAD_IMAGES = {
  SUSPENDED: '49da849b12a1eeb2fcb4773705ee7feb7874a37bd82a2530e30e6254782cdd5d.png',
};

Object.keys(LAUNCHPAD_IMAGES).forEach((key) => (LAUNCHPAD_IMAGES[key] = [PREFIX_STATIC, LAUNCHPAD_IMAGES[key]].join('')));

const PREFIX_RECEIVE_V2 = `${SERVICES.IMG_URL}/v1/`;

export const IMAGES_V2 = {
  ARROW_BLUE: 'cd807142-891c-4a35-9666-820d8c1ae8fd/long.svg',
  ARROW_GREY: '50cf7e2d-4d71-485c-9d24-89865023cf94/long-1.svg',
  ADDRESS: '19144f6c-00b2-4414-9151-22a22110f2cd/address.svg',
  ARROW_SMALL: '0979c0c4-863e-421e-84bd-df80325794ff/small.svg',
  COPY: 'a3a764cf-3ffa-4b49-a458-980bb52eb5ff/copy.svg',
  QUESTION: '4861a12c-12b0-4670-aef2-695ddced5322/question.svg',
  CLOSE: '12e4aab4-130c-4cbf-8084-4bd6381daa9e/close.svg',
  INFO: '43f94f62-3d5b-45d1-ac86-132ed3ccdc4c/info.svg',
  LAMP: '2318b5c3-5fcf-43d3-8094-8701c86e426a/lamp.svg',
  LOCK: '062a3b91-d2df-4723-8bfc-adf98240c085/lock.svg',
  FRAME: 'bae20102-cbaf-487e-a08b-e0b6a99d8e82/frame-1.svg',
  TRANSFER: '57306801-a64a-4445-8de4-dd49dec4cddc/transfer.svg',
  FREE: 'd6e1ae08-ef63-4860-82bc-08075ceebdea/frame-14-3x.png',
  ADD: 'd2d9e067-8ca9-447f-8490-ab2b781e00d0/add.svg',
  ADD_1: '1cabda47-b282-4c5e-a856-73d174bdfce7/add-1.svg',
  GOU: 'e4cd1217-7af2-4a6e-8923-df0eb5744fb4/frame-2.svg',
  WARING: '474ca601-6752-402b-819b-cf8155757a96/icon.svg',
  WARING_ARROW_SMALL: '5f45002c-8210-41ce-8645-fe309886bb88/cs.svg',

  SWITCH_ACCOUNT: 'b8877eeb-1600-4391-b9ea-0c8f277fce6e/active.svg',
  SWITCH_ACCOUNT_NEW: '9e18e689-2e83-4672-8c3a-e4110757b076/active.svg',

  OVERVIEW: '59a80562-a884-4351-9ab7-b01f5ad2e685/overview.svg',
  OVERVIEW_NEW: '2103abe8-352d-495e-87c1-d995179fbb44/overview.svg',
  VERIFICATION: 'cce069df-e8fb-4322-9e08-4c8c4f324e4f/card.svg',
  VERIFICATION_NEW: 'e6133c1a-a99d-446e-a7ae-954759f011ec/card.svg',
  SECURITY: 'd44c7383-3108-4b37-9e8a-5fe58c680534/shield.png',
  SECURITY_NEW: '0f03668e-80aa-4250-9307-47d26bbbee25/shield-4x.svg',
  SUB_ACCOUNT: '53ee179f-2b17-457d-bbb3-4d684fd41bd6/sub-account.svg',
  SUB_ACCOUNT_NEW: '712a03fa-2868-45fd-98f3-e1451f4e324d/sub-account.svg',
  API: '1ef44646-50c2-4bac-90b8-09898ace0f83/api.svg',
  API_NEW: 'b88ccdf4-99f6-4d32-bda4-eeec88fef1f5/api.svg',
  TAX_REPORTING: 'be55ef8b-fa5c-4add-8fed-5c8563f54931/tax-reporting.svg',
  TAX_REPORTING_NEW: '5f03f47f-42f9-42bf-a509-5638121beea7/tax-reporting.svg',
  INVITE_FRIENDS: 'c8ca7458-d655-4b5b-bd56-81985f6d75a8/active.svg',
  INVITE_FRIENDS_NEW: '59b45591-2401-4ccf-b82f-1eee41645e63/active.svg',
  SETTING: '1b4d871e-720e-4877-936e-c07bdecde6f4/setting.svg',
  SETTING_NEW: 'e5d7840a-bc5b-48f9-9b06-cb7611a0c59d/setting.svg',
  LOG_OUT: 'be7fecf0-1efe-47a0-878a-335b0f9c6fe5/active.svg',
  LOG_OUT_NEW: '59153781-de71-4af7-90bf-605ab268428a/active.svg',
  COPY_NEW: 'da1c44c6-f420-4b3b-8eea-13b12293e7c2/copy.svg',

  EXPORT: '1eb09d7c-c16d-43d2-a157-115098f628fe/export.svg',
  EXPORT_HOVER: '9a8d63c3-6908-4c0c-86e7-0f8ec4ee71ca/export.svg',
  EDIT: '4422f319-f340-4add-b1fc-e48198d9dfe4/frame.svg',
  EDIT_H5: 'cb773155-e5c8-4229-8d51-673745a28bf6/frame.svg',
  DELETE_H5: '764e4cb6-e10e-43f3-8388-d99236ca867d/trash.svg',
  SAVE_H5: '63a83fce-b520-4a6f-b2fd-3b85e747533b/tick-circle.svg',
  SAVE: '46aed977-f9ad-4d4b-b867-b73cb5ffcd4c/tick-circle.svg',
  SEARCH: '23c3ac6b-7154-4481-b5f5-0801dda89933/search.svg',
  ICON_INFO: '07c24eb8-ff25-47b4-8482-6cb3f96c1243/info.svg',
  ICON_TICK: '99fa6715-d006-4113-8ae8-fa2ca4e223b1/tick.svg',

  SUCCESS_ICON: '61d84513-dc8e-4cff-95b5-21e6a6f5fbf4/icon-1.svg',
  WARING_ICON: '15b7f1ea-904a-4eff-aa88-02d18eb2f390/icon.svg',
  FAILED_ICON: 'a20b2d8a-7e31-46d6-b1f0-37d8f573835a/frame-1931.svg',
};

Object.keys(IMAGES_V2).forEach((key) => (IMAGES_V2[key] = [PREFIX_RECEIVE_V2, IMAGES_V2[key]].join('')));
